import { login, logout, loginOTP, registration } from './routines';
import type { AuthenticationReducerAction, LoginRoutine } from './interface';
import {
  setAuthCookie,
  clearAllCookies,
  convertExpiresInToExpiresAt,
} from '@utilities/cookies';
export interface State {
  readonly accessToken: string | null;
  readonly expiresAt: number | null;
  readonly provider: string | null;
  readonly refreshToken: string | null;
  readonly scope: string | null;
  readonly tokenType: string | null;
  readonly otpRedirectTo: string;
  readonly isRefreshingToken: boolean;
}

export const getInitialState = (): State => ({
  accessToken: null,
  expiresAt: null,
  provider: null,
  refreshToken: null,
  scope: null,
  tokenType: null,
  otpRedirectTo: '',
  isRefreshingToken: false,
});

export default function reducer(
  state = getInitialState(),
  action: AuthenticationReducerAction
): State {
  switch (action.type) {
    case registration.SUCCESS:
    case login.SUCCESS:
    case loginOTP.SUCCESS: {
      const {
        provider,
        redirectTo = '',
        tokens: { access_token, refresh_token, expires_in, scope, token_type },
      } = action.payload as LoginRoutine['success'];
      const expiresAt = convertExpiresInToExpiresAt(expires_in);
      setAuthCookie(access_token, refresh_token, expiresAt);
      return {
        ...state,
        accessToken: access_token,
        expiresAt,
        scope,
        refreshToken: refresh_token,
        tokenType: token_type,
        provider,
        otpRedirectTo: redirectTo,
        isRefreshingToken: false,
      };
    }
    case loginOTP.FAILURE: {
      return {
        ...state,
        accessToken: '',
        refreshToken: '',
      };
    }
    case logout.TRIGGER: {
      clearAllCookies();
      return getInitialState();
    }
    case logout.SUCCESS: {
      console.log('eating cookies. nom nom nom 🐻');
      clearAllCookies();
      return getInitialState();
    }
    case loginOTP.TRIGGER: {
      // clear the state when logging in through otp
      setAuthCookie('', '');
      return getInitialState();
    }
    default:
      return state;
  }
}
